import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/experience`;

let __storedId = localStorage.getItem("xp_user");
if (!__storedId || __storedId === "demo") {
  __storedId = `guest-${crypto.randomUUID()}`;
  localStorage.setItem("xp_user", __storedId);
}
export const USER_ID = __storedId;

export const newGuest = () => {
  const id = `guest-${crypto.randomUUID()}`;
  track("new_guest", { previous: USER_ID });
  localStorage.setItem("xp_user", id);
  localStorage.setItem("xp_sound_on", "0");
  localStorage.removeItem("xp_picks");
  window.location.assign("/experience");
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  config.headers["X-API-Key"] = process.env.REACT_APP_API_KEY || "";
  const bt = localStorage.getItem("xp_beta_token");
  if (bt) config.headers["X-Beta-Token"] = bt;
  if ((config.url || "").startsWith("/admin")) {
    const t = sessionStorage.getItem("xp_admin_token");
    if (t && !config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && err.response?.data?.beta) {
      localStorage.removeItem("xp_beta_token");
      window.dispatchEvent(new CustomEvent("xp-beta-locked"));
    }
    if (err.response?.status === 401 && url.startsWith("/admin") && !url.startsWith("/admin/unlock")) {
      sessionStorage.removeItem("xp_admin_ok");
      sessionStorage.removeItem("xp_admin_token");
      sessionStorage.removeItem("xp_admin_role");
      if (window.location.pathname.includes("/admin") && !sessionStorage.getItem("xp_admin_kicked")) {
        sessionStorage.setItem("xp_admin_kicked", "1");
        window.location.reload();
      }
    }
    if (err.response?.status === 403 && typeof err.response?.data?.detail === "string"
        && err.response.data.detail.includes("add your phone")) {
      window.dispatchEvent(new CustomEvent("xp-phone-gate"));
    }
    return Promise.reject(err);
  }
);

export const track = (event, props = {}) => {
  const table = localStorage.getItem("xp_table");
  api.post("/events", { event, props: table ? { ...props, table } : props, user_id: USER_ID }).catch(() => {});
};

export const orderHandoff = (url, source) => {
  // V1 kiosk rule: digital menu + experience only — no POS/payment links in guest UI
  track("order_handoff", { source });
  window.dispatchEvent(new CustomEvent("xp-order", { detail: { source } }));
};

export const money = (n) => `$${Number(n).toFixed(2)}`;

export const mkAudio = (url) => {
  const a = new Audio(url);
  const v = window.__xpNarrVol;
  if (typeof v === "number") a.volume = v;
  return a;
};
